import React from "react";
import Box from "@mui/material/Box";

import RackLocationsInput from "../../../../views/capture/RackLocations/RackLocationsInput";
import BaseInfoModal from "./BaseInfoModal";

export default function WarehouseQuantityInfoModal({ asset, onClose }) {
  return (
    <BaseInfoModal title="Warehouse Quantity" onClose={onClose}>
      <Box mt={1}>
        <RackLocationsInput rackLocations={asset.rackLocations} />
      </Box>
    </BaseInfoModal>
  );
}
